
import Product from '@made-people/centra-storyblok-nuxt-shared/lib/views/Product'
import { mapGetters, mapActions } from 'vuex'

export default {
  ...Product,
  fetch () {
    return this.loadYotpoReviews({ sku: this.product.productSku })
  },
  // Yotpo is only until May, so we don't need to add to TTFB for SEO
  fetchOnServer: false,
  head () {
    return {
      title: this.meta.title,
      meta: this.meta.meta,
    }
  },
  computed: {
    ...Product.computed,
    ...mapGetters({
      getCollectionById: 'storyblok/getCollectionById',
      hasProductID: 'wishlist/hasProductID',
      currentLanguageCode: 'frontend/currentLanguageCode',
      currentCountryCode: 'frontend/currentCountryCode',
      generalSettings: 'storyblok/settings',
      getYotpoReviews: 'yotpo/getProductReviews',
    }),
    jsonLd () {
      return JSON.stringify(this.getJsonLds())
    },
    reviews () {
      return this.getYotpoReviews(this.product.productSku)
    },
  },
  serverPrefetch () {
    if (!this.product) {
      return this.fetchProduct()
    }
  },
  methods: {
    getJsonLds () {
      try {
        const product = this.product
        const reviews = this.reviews
        const aggregateRating = {}
        const reviewCount = reviews?.bottomline?.total_review || 0
        if (reviewCount) {
          const ratingValueDec = Math.round(
            reviews.bottomline.average_score * 10
          )
          let ratingValue = ratingValueDec / 10
          if (ratingValueDec % 10 === 0) {
            // Even rating values should not have decimals at all
            ratingValue = Math.abs(ratingValue)
          }
          aggregateRating.aggregateRating = {
            '@type': 'AggregateRating',
            ratingValue,
            reviewCount: reviews.bottomline.total_review,
          }
        }
        if (product) {
          const availability = product.inStock
            ? 'https://schema.org/InStock'
            : 'https://schema.org/OutOfStock'
          const currency =
            this.$store.getters['frontend/pricelist'].currency.currency
          return {
            '@context': 'https://schema.org/',
            '@type': 'Product',
            name: product.name,
            color: product.silkVariantName,
            material: product.google_merchant_material,
            image: [
              this.getImageUrl(
                product.mainImage,
                'extend:1/resize:fit/width:1080/quality:70'
              ),
            ],
            description: product.description.replace(/<br\/>|<br \/>|\n/g, ''),
            sku: product.sku,
            brand: {
              '@type': 'Brand',
              name: this.$nuxt.$options.head.title
            },
            offers: {
              '@type': 'Offer',
              availability,
              price: product.priceAsNumber,
              priceCurrency: currency,
              url: 'https://www.' + this.market.name + this.$u(product.url),
              itemCondition: 'NewCondition',
            },
            ...aggregateRating,
          }
        }
      } catch (e) {
        console.error('Failed to generate product ld+json', e)
      }
      return null
    },
    ...Product.methods,
    ...mapActions({
      loadYotpoReviews: 'yotpo/loadProductReviews',
    }),
    setMeta () {
      const metaTitle = this.product.meta.title || this.product.name

      // Remove tags and replace newlines with '. '
      const metaDescription = (this.product?.meta?.description || this.product.description)
        .replace(/(<([^>]+)>)/ig, '')
        .replace(/\r?\n|\r/g, '. ')
      const canonical = this.$config.baseUrl + this.$u(this.product.url)

      const ogImage = this.product.thumbnailImage || (this.generalSettings && this.generalSettings?.openGraphImage?.filename) || null

      const meta = [
        {
          hid: 'description',
          name: 'description',
          content: metaDescription
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: metaTitle
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: metaDescription
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: canonical
        },
        {
          hid: 'og:type',
          property: 'og:type',
          content: 'website'
        }
      ]

      /**
       * The image is portrait and have to fit into landscape without heads falling off.
       */
      if (ogImage) {
        meta.push({
          hid: 'og:image',
          content: this.$imgproxy.transform(ogImage, 'e:1/rs:fit/w:1200/h:630/q:70'),
          property: 'og:image'
        })
      }
      const pdpMetaTitlePrefix = this.generalSettings?.pdpMetaTitlePrefix !== '' ? this.generalSettings?.pdpMetaTitlePrefix + ' ' : ''
      const pdpMetaTitleSuffix = this.generalSettings?.pdpMetaTitleSuffix !== '' ? ' ' + this.generalSettings?.pdpMetaTitleSuffix : ''
      this.meta.title = pdpMetaTitlePrefix + metaTitle + pdpMetaTitleSuffix
      this.meta.meta = meta

      // ???
      return new Promise((resolve) => {
        resolve(true)
      })
    }
  }
}
